import "./prelude";
import "@nathanvda/cocoon";

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
Rails.start();
ActiveStorage.start();

import "./summernote_image_upload";

import Alpine from "alpinejs";
import "./alpine_globals";
window.Alpine = Alpine;

import { Application } from "@hotwired/stimulus";
import PartnerWeekPeriodsController from "./controllers/partner_week_periods_controller";
import PhoneValidationsController from "./controllers/phone_validations_controller";
import QuickNavigationController from "./controllers/quick_navigation_controller";
import AsyncTableController from "./controllers/async_table_controller";

const application = Application.start();
application.register("partner-week-periods", PartnerWeekPeriodsController);
application.register("phone-validations", PhoneValidationsController);
application.register("quick-navigation", QuickNavigationController);
application.register("async-table", AsyncTableController);

import "./controllers/sortable_table_controller";
import { initDynamicPromotions } from "./dynamic_promotions";

window.addEventListener('DOMContentLoaded', () => {
    initDynamicPromotions();
    Alpine.start();
});
